import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import {
  useInstagramAnalyticsStoryDetailsQuery,
  useInfluencerInstagramAnalyticsStoryDetailsQuery
} from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
  isAnalytics?: boolean;
}

export const Template = ({ className, isAnalytics }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInfluencerInstagramAnalyticsStoryDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || isAnalytics,
    variables: { storyId: Number(selectedPost?.id), socialAccountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });
  const { data: analyticsData, loading: fetchingAnalyticsData } = useInstagramAnalyticsStoryDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || !isAnalytics,
    variables: { storyId: Number(selectedPost?.id), accountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.influencerInstagramAnalyticsStoryDetails || analyticsData?.instagramAnalyticsStoryDetails;

  return (
    <PostModal.DetailsTemplate
      className={className}
      loading={loading || fetchingAnalyticsData}
      data={
        details
          ? {
              socialMedia: 'INSTAGRAM',
              postUrl: details?.postUrl,
              caption: details?.content,
              postDate: details?.postDate,
              images: details?.storyVideoUrl
                ? [details?.storyVideoUrl]
                : details?.postImageUrl
                  ? [details?.postImageUrl]
                  : [],
              statistics: {
                comments: details?.comments,
                reach: details?.reach,
                impressions: details?.impressions,
                exits: details?.exits,
                tapsForward: details?.tapsForward,
                swipeForward: details?.swipeForward,
                tapsBack: details?.tapsBack
              },
              info: {
                avatar: details?.avatarUrl,
                followers: details.followers,
                name: details?.instagramAccountName
              }
            }
          : undefined
      }
    />
  );
};
